var m = {
    CustomEvent: "ce",
    Pr: "p",
    uc: "pc",
    Cc: "ca",
    wu: "i",
    pu: "ie",
    Ut: "cci",
    Wt: "ccic",
    Ht: "ccc",
    Mt: "ccd",
    Al: "ss",
    Dl: "se",
    Gi: "si",
    $i: "sc",
    Fi: "sbc",
    yc: "sfe",
    zo: "iec",
    lc: "lr",
    nc: "uae",
    mc: "lcaa",
    dc: "lcar",
    Gn: "inc",
    Rn: "add",
    On: "rem",
    $n: "set",
    Bn: "ncam",
    fc: "sgu",
    Fr: "ffi",
    ro: "bi",
    ot: "bc"
  },
  Ee = {
    Mc: "content_cards_displayed"
  };
export { m as EventTypes, Ee as InternalEventTypes };